import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["controlId", "statsigLayerId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { fg } from '@atlaskit/platform-feature-flags';
import { STATSIG_SEARCH_BACKEND_L1_LAYER_NAME, STATSIG_SEARCH_BACKEND_L2_LAYER_NAME, STATSIG_SEARCH_BACKEND_L3_LAYER_NAME, STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER_NAME } from '../../constants';
import { getLayerValues } from '../backend';
var WILDCARD = '*';
var JIRA_ENTITY = 'jira';
export var mapCombinedLayerExperiment = function mapCombinedLayerExperiment(_ref) {
  var combinedExperiment = _ref.combinedExperiment;
  if (combinedExperiment) {
    var experimentLayers = getExperimentLayer({
      l1Id: combinedExperiment.l1Id,
      l2Id: combinedExperiment.l2Id,
      l3Id: combinedExperiment.l3Id,
      qrId: combinedExperiment.qrId,
      abTestId: combinedExperiment.abTestId,
      controlId: combinedExperiment.controlId
    });
    return {
      experimentLayers: experimentLayers
    };
  }
  return {
    experimentLayers: []
  };
};
export var mapNonOverlappingBackendExperiment = function mapNonOverlappingBackendExperiment(_ref2) {
  var nonOverlappingExperiment = _ref2.nonOverlappingExperiment;
  if (nonOverlappingExperiment) {
    var experimentLayers = getExperimentLayer({
      l1Id: nonOverlappingExperiment.l1Id,
      l2Id: nonOverlappingExperiment.l2Id,
      l3Id: nonOverlappingExperiment.l3Id,
      qrId: nonOverlappingExperiment.qrId,
      abTestId: nonOverlappingExperiment.abTestId,
      controlId: nonOverlappingExperiment.controlId
    });
    return {
      experimentLayers: experimentLayers
    };
  }
  return {
    experimentLayers: []
  };
};
export var mapDynamicExperiments = function mapDynamicExperiments(_ref3) {
  var dynamicExperiments = _ref3.dynamicExperiments,
    requestedEntities = _ref3.requestedEntities,
    productEdition = _ref3.productEdition,
    isHello = _ref3.isHello,
    productDataRegions = _ref3.productDataRegions,
    experience = _ref3.experience,
    tenantId = _ref3.tenantId,
    isJiraIssueIndexed = _ref3.isJiraIssueIndexed;
  var experiments = dynamicExperiments.filter(containsTenantId(tenantId)).filter(isSameConfluenceTier(productEdition)).filter(containsExperience(experience)).filter(isHelloTenant(isHello)).filter(containsRequestedEntities(requestedEntities)).filter(containsRequestedSubEntities(requestedEntities)).filter(isJiraIssueIndexedConditionSatisfied(isJiraIssueIndexed)).filter(passesTargetingGate()).filter(satisfiesProductDataRegions(productDataRegions)).reduce(function (layerFunctions, currentLayerFunction) {
    // IF there are more than one definitions with the same layerType, hello, entity and subEntity
    // THEN only add the first one defined, (do not add this one)
    var containsCollision = layerFunctions.find(function (layerFunction) {
      return layerFunction.layerType === currentLayerFunction.layerType && (layerFunction.entity === currentLayerFunction.entity || currentLayerFunction.entity === WILDCARD || layerFunction.entity === WILDCARD) && (layerFunction.subEntity === currentLayerFunction.subEntity || currentLayerFunction.subEntity === WILDCARD || layerFunction.subEntity === WILDCARD);
    });
    return containsCollision ? layerFunctions : [].concat(_toConsumableArray(layerFunctions), [currentLayerFunction]);
  }, []).map(function (dynamicExp) {
    var _getLayerValues = getLayerValues(dynamicExp.statsigLayerId),
      layerId = _getLayerValues.layerId,
      shadowId = _getLayerValues.shadowId,
      abTestId = _getLayerValues.abTestId,
      controlId = _getLayerValues.controlId;
    return {
      definition: {
        layerId: layerId,
        shadowId: shadowId,
        entity: dynamicExp.entity,
        subEntity: dynamicExp.subEntity,
        abTestId: abTestId,
        controlId: controlId,
        statsigLayerId: dynamicExp.statsigLayerId
      },
      layerType: dynamicExp.layerType
    };
  });
  var groupedExperimentLayers = experiments.reduce(function (experimentLayers, definitionWithLayerType) {
    var _existingLayer$defini, _existingLayer$analyt;
    var existingLayer = experimentLayers.find(function (layer) {
      return layer.name === definitionWithLayerType.layerType;
    });
    var _definitionWithLayerT = definitionWithLayerType.definition,
      controlId = _definitionWithLayerT.controlId,
      statsigLayerId = _definitionWithLayerT.statsigLayerId,
      newDefinition = _objectWithoutProperties(_definitionWithLayerT, _excluded);
    var analyticsDefinition = _objectSpread({}, definitionWithLayerType.definition);
    if (!existingLayer) {
      experimentLayers.push({
        name: definitionWithLayerType.layerType,
        layerId: null,
        // TODO QS-6283: Remove this once scalable statsig layers are rolled out
        shadowId: null,
        // TODO QS-6283: Remove this once scalable statsig layers are rolled out
        definitions: [newDefinition],
        analyticsDefinitions: [analyticsDefinition]
      });
      return experimentLayers;
    }
    (_existingLayer$defini = existingLayer.definitions) === null || _existingLayer$defini === void 0 || _existingLayer$defini.push(newDefinition);
    (_existingLayer$analyt = existingLayer.analyticsDefinitions) === null || _existingLayer$analyt === void 0 || _existingLayer$analyt.push(analyticsDefinition);
    return experimentLayers;
  }, []);
  return {
    experimentLayers: groupedExperimentLayers
  };
};
export var isSameConfluenceTier = function isSameConfluenceTier(productEdition) {
  return function (dynamicExp) {
    var _dynamicExp$confluenc;
    // Opt for specificity. Does not filter out values that do not have the confluenceTier attribute
    if (!dynamicExp.confluenceTier || dynamicExp.confluenceTier.length === 0) {
      return true;
    }
    return !!((_dynamicExp$confluenc = dynamicExp.confluenceTier) !== null && _dynamicExp$confluenc !== void 0 && _dynamicExp$confluenc.find(function (experimentTier) {
      return (productEdition === null || productEdition === void 0 ? void 0 : productEdition['confluence']) === experimentTier;
    }));
  };
};
var isHelloTenant = function isHelloTenant(isHello) {
  return function (dynamicExp) {
    if (dynamicExp.hello === undefined || dynamicExp.hello === null) {
      return true;
    }
    return dynamicExp.hello === isHello;
  };
};
var passesTargetingGate = function passesTargetingGate() {
  return function (dynamicExp) {
    if (dynamicExp.targetingGateId === undefined || dynamicExp.targetingGateId === null) {
      return true;
    }
    if (fg('search_experiment_targeting_gate_targeting_enabled')) {
      // eslint-disable-next-line @atlaskit/platform/static-feature-flags
      return fg(dynamicExp.targetingGateId);
    }
    return true;
  };
};

/**
 * This is specifically used for targeting based on indexing status of the tenant.
 * This might NOT be needed once Jira indexed and ROVO in Jira is shipped to 100%
 */
var isJiraIssueIndexedConditionSatisfied = function isJiraIssueIndexedConditionSatisfied(isJiraIssueIndexed) {
  return function (dynamicExp) {
    if (isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === undefined || dynamicExp.isJiraIssueIndexed === null || (dynamicExp === null || dynamicExp === void 0 ? void 0 : dynamicExp.entity) !== JIRA_ENTITY) {
      return true;
    }
    if (fg('search_experiment_targeting_jira_indexed_enabled')) {
      return dynamicExp.isJiraIssueIndexed === isJiraIssueIndexed;
    }
    return true;
  };
};
var containsRequestedEntities = function containsRequestedEntities(entityFilter) {
  return function (dynamicExp) {
    if (!dynamicExp.entity || dynamicExp.entity === WILDCARD) {
      return true;
    }
    var isFilteredEntity = entityFilter.find(function (filteredEntity) {
      return dynamicExp.entity === filteredEntity.entity;
    });
    return isFilteredEntity !== null && isFilteredEntity !== void 0 ? isFilteredEntity : false;
  };
};
var containsRequestedSubEntities = function containsRequestedSubEntities(entityFilter) {
  return function (dynamicExp) {
    if (!dynamicExp.subEntity || dynamicExp.subEntity === WILDCARD) {
      return true;
    }
    var isFilteredSubEntity = entityFilter.find(function (filteredEntity) {
      return dynamicExp.subEntity === filteredEntity.subEntity;
    });
    return isFilteredSubEntity !== null && isFilteredSubEntity !== void 0 ? isFilteredSubEntity : false;
  };
};

/**
 * Determines whether the provided data regions (dataRegions) are defined in
 * the dynamic configuration (dynamicExp). Every data region for a given product
 * in the dynamic configuration must be specified  in order for the given
 * experiment layer to be eligible.
 *
 * @param dataRegions Represents where the data comes from comes from for
 * each product.
 * ```
 * { 'confluence': ["us-west-2"], 'compass': ["us-east-1"] }`
 * ```
 *
 * @returns a boolean that indicates whether or not the provided data regions
 * (dataRegions) are specified in the dynamic configuration (dynamicExp).
 */
var satisfiesProductDataRegions = function satisfiesProductDataRegions(dataRegions) {
  return function (dynamicExp) {
    if (!dynamicExp.productDataRegions) {
      return true;
    }
    return Object.keys(dynamicExp.productDataRegions).map(function (product) {
      var _dynamicExp$productDa, _dataRegions$product;
      var productDataRegions = (_dynamicExp$productDa = dynamicExp.productDataRegions) === null || _dynamicExp$productDa === void 0 ? void 0 : _dynamicExp$productDa[product];
      var isProductEligible = dataRegions === null || dataRegions === void 0 || (_dataRegions$product = dataRegions[product]) === null || _dataRegions$product === void 0 ? void 0 : _dataRegions$product.every(function (dataRegion) {
        return productDataRegions === null || productDataRegions === void 0 ? void 0 : productDataRegions.includes(dataRegion);
      });
      return !!isProductEligible;
    }).reduce(function (prev, curr) {
      return prev && curr;
    });
  };
};
var containsExperience = function containsExperience(experience) {
  return function (dynamicExp) {
    var _dynamicExp$experienc;
    if (!dynamicExp.experiences || dynamicExp.experiences.length === 0) {
      return true;
    }
    return (_dynamicExp$experienc = dynamicExp.experiences) === null || _dynamicExp$experienc === void 0 ? void 0 : _dynamicExp$experienc.find(function (dynamicExpExperience) {
      return experience === dynamicExpExperience;
    });
  };
};
var containsTenantId = function containsTenantId(tenantId) {
  return function (dynamicExp) {
    var _dynamicExp$tenantIds;
    if (!dynamicExp.tenantIds || dynamicExp.tenantIds.length === 0) {
      return true;
    }
    return (_dynamicExp$tenantIds = dynamicExp.tenantIds) === null || _dynamicExp$tenantIds === void 0 ? void 0 : _dynamicExp$tenantIds.find(function (dynamicExpTenantId) {
      return tenantId === dynamicExpTenantId;
    });
  };
};
var getExperimentLayer = function getExperimentLayer(_ref4) {
  var l1Id = _ref4.l1Id,
    l2Id = _ref4.l2Id,
    l3Id = _ref4.l3Id,
    qrId = _ref4.qrId,
    abTestId = _ref4.abTestId,
    controlId = _ref4.controlId;
  var experimentLayers = [[STATSIG_SEARCH_BACKEND_L1_LAYER_NAME, l1Id], [STATSIG_SEARCH_BACKEND_L2_LAYER_NAME, l2Id], [STATSIG_SEARCH_BACKEND_L3_LAYER_NAME, l3Id], [STATSIG_SEARCH_BACKEND_QUERY_EXPANSION_LAYER_NAME, qrId]];
  return experimentLayers.map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
      layerType = _ref6[0],
      layerId = _ref6[1];
    return {
      name: layerType,
      layerId: null,
      shadowId: null,
      definitions: [{
        layerId: layerId,
        shadowId: null,
        entity: WILDCARD,
        subEntity: WILDCARD,
        abTestId: abTestId !== null && abTestId !== void 0 ? abTestId : null
      }],
      analyticsDefinitions: [{
        layerId: layerId,
        shadowId: null,
        entity: WILDCARD,
        subEntity: WILDCARD,
        abTestId: abTestId !== null && abTestId !== void 0 ? abTestId : null,
        controlId: controlId !== null && controlId !== void 0 ? controlId : null
      }]
    };
  });
};